import { Grid } from '@material-ui/core'
import { makeStyles } from '@material-ui/core'
import React from 'react'
import EFooter from './view/_footer'


const useStyles=makeStyles((theme)=>({
    footerContainer:{
        // display:"flex",
        // justifyContent:"center",
        flexGrow: 1,
        textAlign: "center",
        paddingBottom:'1rem'
    }
}))

function EFooterSection() {
    const classes=useStyles()
    
  return (
    <Grid container justify='center'>
        <Grid item xs={12} className={classes.footerContainer}>
            <EFooter/>
        </Grid>
    </Grid>
  )
}

export default EFooterSection
